import styled from 'styled-components';

export const ButtonWrapper = styled.button`
  width: 100%;
`;
